export const CARS = [
    {
        id: 1,
        brand: 'Porsche',
        model: '911',
        price: 16000,
        yearManufactured: 2023,
        color: 'Red',
        img: 'https://acroadtrip.blob.core.windows.net/catalogo-imagenes/xl/RT_V_655b66b7b2814ee9a866a1692313f7f1.jpg',
        otherDetails: 'Iconic sports car with exceptional performance'
    },
    {
        id: 2,
        brand: 'Toyota',
        model: 'Camry',
        price: 28000,
        yearManufactured: 2022,
        color: 'Silver',
        img: 'https://imgd.aeplcdn.com/664x374/n/cw/ec/131135/xc90-exterior-right-front-three-quarter-106.jpeg?isig=0&q=80&q=80',
        otherDetails: 'Reliable and fuel-efficient sedan'
    },
    {
        id: 3,
        brand: 'Ford',
        model: 'Mustang',
        price: 45000,
        yearManufactured: 2023,
        color: 'Blue',
        img: 'https://derco-pe-prod.s3.amazonaws.com/images/versions/2022-07-20-MAZDA_NEWCX5_SIGNATURE.png',
        otherDetails: 'Classic American muscle car'
    },
    {
        id: 4,
        brand: 'Honda',
        model: 'Civic',
        price: 24000,
        yearManufactured: 2022,
        color: 'Black',
        img: 'https://www.ramlatam.com/ec/wp-content/uploads/sites/2/vehiculos/ram-1500/ram-1500-all-new.png',
        otherDetails: 'Popular compact car known for its reliability'
    },
    {
        id: 5,
        brand: 'Chevrolet',
        model: 'Silverado',
        price: 38000,
        yearManufactured: 2023,
        color: 'Gray',
        img: 'https://crdms.images.consumerreports.org/c_lfill,w_470,q_auto,f_auto/prod/cars/chrome/white/2021VWC020017_1280_01',
        otherDetails: 'Full-size pickup truck with towing capacity'
    },
    {
        id: 6,
        brand: 'BMW',
        model: 'X5',
        price: 65000,
        yearManufactured: 2023,
        color: 'White',
        img: 'https://www.lexus.com.ph/content/dam/lexus-v3-blueprint/models/suv/rx/rx-500h-fsport-performance/my23/masthead/my23-rx500h-fsport-performance-masthead-083-white-nova-glass-flake.png',
        otherDetails: 'Luxury SUV with advanced features'
    },
    {
        id: 7,
        brand: 'Audi',
        model: 'A4',
        price: 42000,
        yearManufactured: 2023,
        color: 'Silver',
        img: 'https://www.chevrolet.com.pe/content/dam/chevrolet/south-america/peru/espanol/index/pickups-and-trucks/2023-silverado/01-images/colorizer/02-images/silverado-z71-trailboss-blanco-perla.png?imwidth=960',
        otherDetails: 'Compact luxury sedan with a sleek design'
    },
    {
        id: 8,
        brand: 'Tesla',
        model: 'Model 3',
        price: 49900,
        yearManufactured: 2023,
        color: 'Blue',
        img: 'https://www.ford.pe/content/dam/Ford/website-assets/latam/pe/nameplate/new-f-150/2021/models/doble-cabina-3-3l-4x4-xlt_lariat/thumbnails/fpe-f-150-lariat-omparador.png',
        otherDetails: 'Electric car with cutting-edge technology'
    },
    {
        id: 9,
        brand: 'Mercedes-Benz',
        model: 'C-Class',
        price: 53000,
        yearManufactured: 2023,
        color: 'Black',
        img: 'https://mediaservice.audi.com/media/live/50900/fly1400x601n1/gbaasg/2023.png?wid=850',
        otherDetails: 'Luxury sedan with a comfortable interior'
    },
    {
        id: 10,
        brand: 'Jeep',
        model: 'Wrangler',
        price: 36000,
        yearManufactured: 2023,
        color: 'Green',
        img: 'https://www.jeep.pe/wp-content/uploads/sites/4/2020/08/VFUnlimitedRubicon_GrisGranito-1.png',
        otherDetails: 'Off-road SUV with rugged capabilities'
    },
    {
        id: 11,
        brand: 'Subaru',
        model: 'Outback',
        price: 33000,
        yearManufactured: 2023,
        color: 'Red',
        otherDetails: 'All-wheel drive crossover for outdoor enthusiasts',
        img: 'https://www.interseguro.pe/soat/imagenes/landing/kia-optima.jpg'
    },
    {
        id: 12,
        brand: 'Lexus',
        model: 'RX',
        price: 52000,
        yearManufactured: 2023,
        color: 'Silver',
        otherDetails: 'Luxury SUV with a spacious interior',
        img: 'https://edgecast-img.yahoo.net/mysterio/api/F5536165B1055F1EF3699C83603DF464F48D753E024D2E01657FD6DE72575E5C/autoblog/resizefill_w660_h372;quality_80;format_webp;cc_31536000;/https://s.aolcdn.com/commerce/autodata/images/CAD10NIS112C021001.jpg'
    },
    {
        id: 13,
        brand: 'Nissan',
        model: 'Altima',
        price: 27000,
        yearManufactured: 2023,
        color: 'Gray',
        img: 'https://www.tesla.com/ownersmanual/images/GUID-B5641257-9E85-404B-9667-4DA5FDF6D2E7-online-en-US.png',
        otherDetails: 'Midsize sedan with good fuel efficiency'
    },
    {
        id: 14,
        brand: 'Volkswagen',
        model: 'Golf',
        price: 29000,
        yearManufactured: 2023,
        color: 'Blue',
        otherDetails: 'Compact hatchback known for its handling',
        img: 'https://www.subaru.com.pe/subaru/site/artic/20210512/imag/foto_0000002120210512141558/Outback_Limited_Blanco_Cristal_Perlado.png'
    },
    {
        id: 15,
        brand: 'Hyundai',
        model: 'Tucson',
        price: 32000,
        yearManufactured: 2023,
        color: 'White',
        otherDetails: 'Compact SUV with modern features',
        img: 'https://estaticos-cdn.sport.es/clip/41a0bdc1-2635-4c08-9e11-2cdf2619b88f_alta-libre-aspect-ratio_default_0.jpg'
    },
    {
        id: 16,
        brand: 'Mazda',
        model: 'CX-5',
        price: 34000,
        yearManufactured: 2023,
        color: 'Red',
        otherDetails: 'Crossover SUV with sporty styling',
        img: 'https://maquinarias.pe/wp-content/uploads/2021/08/tucson-1.png'
    },
    {
        id: 17,
        brand: 'Kia',
        model: 'Sorento',
        price: 35000,
        yearManufactured: 2023,
        color: 'Gray',
        otherDetails: 'Midsize SUV with spacious seating',
        img: 'https://www.bmw.com.pe/content/dam/bmw/common/all-models/3-series/sedan/2022/navigation/bmw-3-series-sedan-lci-modelfinder.png'
    },
    {
        id: 18,
        brand: 'Volvo',
        model: 'XC90',
        price: 61000,
        yearManufactured: 2023,
        color: 'Black',
        otherDetails: 'Luxury SUV with advanced safety features',
        img: 'https://www.motortrend.com/uploads/sites/10/2017/11/2013-chevrolet-malibu-eco-sedan-angular-front.png'
    },
    {
        id: 19,
        brand: 'Chrysler',
        model: '300',
        price: 42000,
        yearManufactured: 2023,
        color: 'Silver',
        otherDetails: 'Full-size sedan with a comfortable ride',
        img: 'https://www.toyota.com/imgix/content/dam/toyota/jellies/max/2024/camry/xse/2548/2pt/36/5.png?fm=png&w=930&q=90'
    },
    {
        id: 20,
        brand: 'Acura',
        model: 'MDX',
        price: 52000,
        yearManufactured: 2023,
        color: 'Blue',
        otherDetails: 'Luxury SUV with a refined interior',
        img: 'https://maquinarias.pe/wp-content/uploads/2022/09/honda_civic.png'
    },
    {
        id: 21,
        brand: 'GMC',
        model: 'Sierra',
        price: 40000,
        yearManufactured: 2023,
        color: 'White',
        otherDetails: 'Full-size pickup truck with towing capability',
        img: 'https://panaautos.com.pe/wp-content/uploads/2023/01/crv2023-1.jpg'
    },
];
